// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BaseFormValidatorController from "./base_form_validator_controller"
application.register("base-form-validator", BaseFormValidatorController)

import BenchmarkController from "./benchmark_controller"
application.register("benchmark", BenchmarkController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstallmentsDashboardController from "./installments_dashboard_controller"
application.register("installments-dashboard", InstallmentsDashboardController)

import InvoiceHistoryController from "./invoice_history_controller"
application.register("invoice-history", InvoiceHistoryController)

import InvoicesController from "./invoices_controller"
application.register("invoices", InvoicesController)

import ListingsController from "./listings_controller"
application.register("listings", ListingsController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import ReliabilitiesDashboardController from "./reliabilities_dashboard_controller"
application.register("reliabilities-dashboard", ReliabilitiesDashboardController)

import UnreadBadgeController from "./unread_badge_controller"
application.register("unread-badge", UnreadBadgeController)

import UploadsController from "./uploads_controller"
application.register("uploads", UploadsController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import PaymentNotificationController from "./payment_notification_controller"
application.register("payment-notification", PaymentNotificationController)
